const features = [
  {
    icon: 'ri-radar-line',
    title: '全天候监控',
    desc: '7×24小时不间断追踪主流平台网红动态，智能抓取异常信息，第一时间发现塌房信号，让你永远快人一步吃到最新鲜的瓜。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多方交叉验证',
    desc: '每一条网红黑料都经过多渠道信息交叉比对核实，绝不传播未经确认的谣言。我们坚持有图有真相，为吃瓜群众提供最可靠的信息。',
  },
  {
    icon: 'ri-archive-drawer-line',
    title: '海量黑料档案',
    desc: '长期积累网红黑料数据库，覆盖抖音、快手全平台头部及腰部网红。塌房翻车历史记录完整归档，不怕网红事后洗白否认。',
  },
  {
    icon: 'ri-group-line',
    title: '千万吃瓜群众',
    desc: '全网最大的吃瓜社群聚集地。在这里你能找到志同道合的瓜友，一起讨论最新网红黑料，分享独家线索，共同见证每一个塌房现场。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">为什么选择我们</h2>
            <p className="mt-2 text-sm text-foreground-500">在众多网红黑料平台中脱颖而出的四大理由</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {features.map((feat, idx) => (
              <div
                key={idx}
                className="group p-6 rounded-xl bg-background-200/70 border border-background-300/40 hover:border-accent-500/25 transition-all duration-300 text-center"
              >
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-xl bg-accent-500/15 text-accent-500 transition-transform duration-300 group-hover:scale-110">
                  <i className={`${feat.icon} text-2xl`}></i>
                </div>
                <h3 className="mt-5 text-base font-semibold text-foreground-900">{feat.title}</h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}